import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { AddIcon } from '@treams/treams-icons';
import { PageType } from '@treams/treams-network';
import { Button, Container, FlexGap, Jumbo, tokens } from '@treams/treams-ui';

export default function GrowthPathHeader(props: {
	title: string;
	description?: string;
	children?: ReactNode;
	editable?: boolean;
	extra?: ReactNode;
	actions?: ReactNode;
}) {
	const { t } = useTranslation();
	const location = useLocation();

	const button = (
		<FlexGap gap={tokens.gap.list} alignItems="center">
			<Button
				title={t('career.detail.askFeedback')}
				icon={<AddIcon />}
				link={`/feedback/request/competencies?return=${location.pathname}`}
			/>
			{props.actions}
		</FlexGap>
	);

	if (props.editable) {
		return (
			<>
				<Jumbo.Editable
					wide
					page={PageType.Skills}
					title={props.title}
					description={props.description}
					button={button}
				/>
				{props.extra && <Container wide>{props.extra}</Container>}
			</>
		);
	}

	return (
		<>
			<Jumbo wide title={props.title} description={props.description} button={button}>
				{props.children}
			</Jumbo>
			{props.extra && <Container wide>{props.extra}</Container>}
		</>
	);
}
